import fetchJSON from 'lib/fetchJSON'
import { Map } from 'immutable'
const { encodeURIComponent } = window

export const buildSearchURL = ({ userId, sortBy, ...rest }) => {
  // map javascript camel case to rails snake case and compact out undefined
  // values
  const params = Map({
    user_id: userId,
    sort_by: sortBy,
    ...rest
  }).filter(v => v)

  // generate a url-encoded query string
  const queryString = params.map((val, key) => {
    const fullKey = encodeURIComponent(`search[${key}]`)
    const escapedValue = encodeURIComponent(val)
    return `${fullKey}=${escapedValue}`
  }).join('&')

  return `/find/search?${queryString}`
}

export const searchRides = (params) => fetchJSON(buildSearchURL(params))
